'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';

export type UmamiLoaderProps = {
  subdomainUmamiId: string | null;
  customDomainUmamiId: string | null;
  urlPrefixUmamiId: string | null;
  subdomain: string | null;
  customDomain: string | null;
  urlPrefix: string | null;
};

export function UmamiLoader({
  subdomainUmamiId,
  customDomainUmamiId,
  urlPrefixUmamiId,
  urlPrefix,
  customDomain,
  subdomain,
}: UmamiLoaderProps): JSX.Element {
  const [umamiId, setUmamiId] = useState<string | null>(null);
  useEffect(() => {
    const domain = location.hostname;
    let id = urlPrefixUmamiId || customDomainUmamiId || subdomainUmamiId;
    // subdomain can be used for url prefix,
    // need to distinguish them in browser
    if (domain.endsWith('.quotion.co')) {
      id = subdomainUmamiId;
    }
    setUmamiId(id);
  }, [urlPrefixUmamiId, customDomainUmamiId, subdomainUmamiId]);

  if (!umamiId) {
    return <></>;
  }
  let domains = `${subdomain}.quotion.co`;
  if (customDomain) {
    domains += `,${customDomain}`;
  }
  if (urlPrefix) {
    domains += `,${urlPrefix.replace('https://', '')}`;
  }
  return (
    <Script
      key={umamiId}
      src="https://use-umami.vercel.app/script.js"
      data-website-id={umamiId}
      defer
      strategy="afterInteractive"
      data-domains={domains}
    />
  );
}
